module.exports = __webpack_public_path__ + "img/double-arrow-right.d411a726.svg";